import { render, staticRenderFns } from "./tab.mpx?vue&type=template&id=29d84a9b&scoped=true&component=true&componentId=tab6691b08a"
import script from "./tab.mpx?vue&type=script&lang=js&component=true&componentId=tab6691b08a"
export * from "./tab.mpx?vue&type=script&lang=js&component=true&componentId=tab6691b08a"
import style0 from "./tab.mpx?vue&type=style&index=0&id=29d84a9b&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m6691b08a%22%7D&component=true&componentId=tab6691b08a"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d84a9b",
  null
  
)

export default component.exports